module.exports = __webpack_public_path__ + "static/media/web.14d57fbe.svg";